import type { Tone } from '../../model/pulse-readings'

/**
 * The screen answers to the prototype's palette, not the terminal's, so a tone
 * maps onto the custom properties the lifted stylesheet declares.
 */
export const toneVar = (tone: Tone): string => {
  switch (tone) {
    case 'good': {
      return 'var(--up)'
    }
    case 'bad':
    case 'loud': {
      return 'var(--down)'
    }
    case 'watch': {
      return 'var(--warn)'
    }
    case 'quiet': {
      return 'var(--t2)'
    }
  }
}
